import {
  rentersPolicyAvailable,
  standaloneRentersStates,
  condoStates,
  policyType,
  lookupsJson
} from '@ourbranch/lookups';
import { isPolicyTypeEnabled } from 'common/helpers/environment-helpers';

const useAvailablePolicies = (state) => {
  if (!state) {
    return lookupsJson.policyTypes.filter((opt) => isPolicyTypeEnabled(opt.id));
  }
  const isRentersAvailable = rentersPolicyAvailable[state];
  const isStandaloneRentersAvailable = standaloneRentersStates[state];
  const isCondoAvailable = condoStates[state];

  return lookupsJson.policyTypes.filter((opt) => {
    if (!isPolicyTypeEnabled(opt.id)) {
      return false;
    }

    // Apply state-based availability rules for Condo and Renters
    if (opt.id.includes(policyType.Condo)) {
      return isCondoAvailable;
    }
    if (opt.id === policyType.ARBundle) {
      return isRentersAvailable;
    }
    if (opt.id === policyType.Renters) {
      return isStandaloneRentersAvailable;
    }

    return true;
  });
};

export default useAvailablePolicies;
